import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Tag, Button, Input, message, Empty, Tooltip } from 'antd';
import { CopyOutlined, SearchOutlined, UserOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import SurveyService from '../../services/SurveyService';

export default function QoCSurveyTemplateLibrary() {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cloning, setCloning] = useState(null);
    const [search, setSearch] = useState('');

    const load = () => {
        setLoading(true);
        SurveyService.getTemplateLibrary()
            .then(r => setTemplates(r.data?.data || []))
            .catch(e => message.error(e.response?.data?.message || 'Failed to load template library'))
            .finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, []);

    const handleClone = async (template) => {
        setCloning(template.id);
        try {
            await SurveyService.cloneTemplate(template.id);
            message.success(`"${template.title}" copied — find it under your own surveys to customise and start collecting.`);
        } catch (e) {
            message.error(e.response?.data?.message || 'Clone failed');
        } finally { setCloning(null); }
    };

    const filtered = templates.filter(t =>
        !search || t.title.toLowerCase().includes(search.toLowerCase()) ||
        (t.category || '').toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="page-content">
            <div className="page-head d-flex">
                <div className="my-auto">
                    <h4 style={{ margin: 0 }}>National Template Library</h4>
                    <small className="text-muted">
                        Standardised tools approved by national — use one instead of building from scratch
                    </small>
                </div>
                <div className="my-auto ml-auto" style={{ width: 260 }}>
                    <Input placeholder="Search templates..." prefix={<SearchOutlined />}
                        value={search} onChange={e => setSearch(e.target.value)} allowClear />
                </div>
            </div>
            <div className="page-pad">
                {filtered.length === 0 && !loading ? (
                    <Card size="small"><Empty description="No published templates yet" /></Card>
                ) : (
                    <Row gutter={16}>
                        {filtered.map(t => (
                            <Col span={8} key={t.id} style={{ marginBottom: 16 }}>
                                <Card size="small" style={{ height: '100%' }}
                                    title={<span style={{ fontSize: 13 }}>{t.title}</span>}
                                    extra={t.category && <Tag>{t.category}</Tag>}>
                                    <div style={{ fontSize: 12, color: '#555', minHeight: 40, marginBottom: 10 }}>
                                        {t.description || 'No description provided.'}
                                    </div>
                                    <div style={{ display: 'flex', gap: 14, fontSize: 11, color: '#888', marginBottom: 12 }}>
                                        <Tooltip title="Original creator">
                                            <span><UserOutlined /> {t.owner_name || 'Unknown'}</span>
                                        </Tooltip>
                                        <Tooltip title="Number of questions">
                                            <span><QuestionCircleOutlined /> {t.question_count} questions</span>
                                        </Tooltip>
                                    </div>
                                    {t.adoption_count > 0 && (
                                        <Tag color="blue" style={{ marginBottom: 10 }}>
                                            Adopted by {t.adoption_count} region{t.adoption_count !== 1 ? 's' : ''}
                                        </Tag>
                                    )}
                                    <Button type="primary" icon={<CopyOutlined />} block
                                        loading={cloning === t.id}
                                        onClick={() => handleClone(t)}>
                                        Use This Tool
                                    </Button>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}
            </div>
        </div>
    );
}
